module.exports = __webpack_public_path__ + "static/045-b283c240c352d825bd3e8626c5f51883.jpg";